import type { Activity } from '../../types/health';
import { DataSourceLabel } from '../ui/DataSourceLabel';
import { StatusBadge } from '../ui/StatusBadge';
import './ActivityCard.css';

export function ActivityCard({ activity }: { activity: Activity }) {
  return (
    <article className="activity-card">
      <div>
        <h3>{activity.title}</h3>
        <div className="activity-meta">
          <span>{activity.type}</span>
          <span className="numeric">{activity.durationMinutes} min</span>
          {activity.rpe ? <span className="numeric">RPE {activity.rpe}</span> : null}
        </div>
      </div>
      <div className="activity-side">
        <StatusBadge tone="neutral">{new Date(activity.startTime).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</StatusBadge>
        <DataSourceLabel source={activity.source} />
      </div>
    </article>
  );
}
